<script>
import MethodButtonBase from './MethodButtonBase';
import IconBankId from '../../assets/svg/no-bankid-logo.svg';
export default {
  name: 'NoBankIdButton',
  components: {
    MethodButtonBase,
    IconBankId,
  },
}
</script>

<template>
  <MethodButtonBase>
    <template v-slot:slot1>
      <IconBankId :class="$style.icon" />
    </template>
  </MethodButtonBase>
</template>


<style lang="scss" module>
.icon {
  display: block;
  width: 102px;
  height: auto;
  margin-top: -1px;
}
</style>
